"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailPreviewSubject = exports.getEmailPreviewData = exports.getIsFulfilled = exports.getIsPending = exports.getStatus = exports.getEmailPreviewState = void 0;

var _utils = require("@alycecom/utils");

var _ramda = require("ramda");

var getEmailPreviewState = function getEmailPreviewState(state) {
  return state.modules.giftEmailPreview;
};

exports.getEmailPreviewState = getEmailPreviewState;
var getStatus = (0, _ramda.pipe)(getEmailPreviewState, (0, _ramda.prop)('status'));
exports.getStatus = getStatus;
var getIsPending = (0, _ramda.pipe)(getStatus, (0, _ramda.equals)(_utils.StateStatus.Pending));
exports.getIsPending = getIsPending;
var getIsFulfilled = (0, _ramda.pipe)(getStatus, (0, _ramda.equals)(_utils.StateStatus.Fulfilled));
exports.getIsFulfilled = getIsFulfilled;
var getEmailPreviewData = (0, _ramda.pipe)(getEmailPreviewState, (0, _ramda.prop)('previewData'));
exports.getEmailPreviewData = getEmailPreviewData;
var getEmailPreviewSubject = (0, _ramda.pipe)(getEmailPreviewState, (0, _ramda.pathOr)('', ['previewData', 'subject']));
exports.getEmailPreviewSubject = getEmailPreviewSubject;